module.exports = __webpack_public_path__ + "static/media/close.07c94224.png";